<template>
  <w-vue-select
    label-field="name"
    value-field="name"
    :model="schoolModel.schoolName"
    :values="options"
    :ajax="!isSecretary"
    @search="search"
    @input="updateSchoolData"
  />
</template>

<script>
import components from '@witkac/bootstrap4-components/src/components/formComponents';

import { schoolPickerSecretaryMixin } from '@/mixins/schoolPickerSecretary';

// @vuese
// Wybierak szkoły z filtrowaniem węzłów sekretarki
// @group Forms
export default {
  components,
  mixins: [schoolPickerSecretaryMixin],
  methods: {
    updateSchoolData(selectedSchool) {
      this.schoolModel.nodeId.$setData(selectedSchool.id);
    }
  }
};
</script>
